import PropTypes from "prop-types";
import capitalize from "capitalize";
import { UserSolidV6 } from "@shared/v2/Icomoon";
import BaseEvent from "./BaseEvent";
import HomeInfoOverlay from "./HomeInfoOverlay";

const FORMATTED_KEYS = {
  Amount: "Offer Amount",
  "Need financing_advice": "Mortgage Pre-Approval",
  "Have seen_home_in_person": "Have Seen Home In Person",
  Position: "Position",
  Date: "Date",
  Resume: "Resume",
  "Submitted on": "Submitted On",
  "Form source_url": "Form Source URL",
};

const getTitle = (comments) => {
  let title = "Contact Form";
  if (comments.startsWith("Make offer form from mobile")) {
    title = "Make An Offer";
  }
  return title;
};

const TimelineContactFormEvent = ({
  event,
  event: {
    timeline_fields: { property, ...timelineFields },
  },
}) => {
  const descriptions = timelineFields.comments.split(/<br \/>|<br>/).map((detail) => {
    // eslint-disable-next-line prefer-const
    let [key, value] = detail.split(": ");
    const formattedKey = FORMATTED_KEYS[key];

    if (formattedKey) {
      value = value.replace("Http", "http");
      value = value.replace("$ ", "$");
      value = capitalize(value);

      return `${formattedKey}: ${value}`;
    }
    return detail;
  });

  return (
    <BaseEvent
      title={
        <div>
          <span className="tw-font-semibold">Submitted Form: </span>
          {getTitle(timelineFields.comments)}
        </div>
      }
      icon={<UserSolidV6 />}
      onClick={() => {
        if (property?.url) window.open(property.url);
      }}
      interactedAt={event.interacted_at_absolute}
    >
      {property && <HomeInfoOverlay timelineFields={property} />}
      {descriptions.length > 0 && <div className="tw-font-semibold">Details:</div>}
      {descriptions.map((d) => (
        <div key={`${event.id}-${d}`}>{d}</div>
      ))}
    </BaseEvent>
  );
};

TimelineContactFormEvent.propTypes = {
  event: PropTypes.shape().isRequired,
};

export default TimelineContactFormEvent;
